import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {FueltaxService} from '../../service/fueltax/fueltaxService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';


/* global customElements */
class StateTaxTypeGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var typeGrid = this;
		setTimeout(function(){
			typeGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var typeGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [								
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'taxMethodType',
					postinit: function(combo) {						
						var lookups = [
							{
								code: 'taxMethodType',
								description: 'Type'								
							},
							{
								code: 'scheduleCode',
								description: 'Schedule Code'	
							}
						];
						combo.items = lookups;						
					},
					placeHolder: 'Select'					
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter Value',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				}
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_STATE_TAX_RATES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_STATE_TAX_RATES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['ADMIN_STATE_TAX_RATES:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', 'Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							theme: 'error primary',					
							permissions: ['ADMIN_STATE_TAX_RATES:DELETE'],
							'class': 'spacer-toolbar-item',								
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [	
				{						
					path: 'stateTaxTypeCode',
					header: 'Type',
					width: '7em'
				},
				{						
					path: 'stateTaxTypeDesc',
					header: 'Description',
					width: '7em'
				},
				{						
					path: 'taxMethodTypeDesc',
					header: 'Method',					
					width: '9em'
				},
				{						
					path: 'scheduleCodeDesc',
					header: 'Schedule',
					width: '7em'
				},
				{						
					path: 'tableCodeDesc',
					header: 'Table',				
					width: '7em'
				},
				{						
					path: 'stateProvCode',
					header: 'State/Prov',
					'text-align': 'center',
					width: '9em'
				},
				{						
					path: 'haulTypeDesc',
					header: 'haulType',
					width: '7em'
				},
				{						
					path: 'ladenUnleadCodeDesc',
					header: 'Laden/Unladen',
					'text-align': 'center',
					width: '9em'
				},	
				{						
					path: 'taxTractorTruckIndicatorDesc',
					header: 'Vehicle Type',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'incrementalMaxCalcFlag',
					header: 'Max Calc Flag',
					'text-align': 'center',
					width: '9em'
				},
				{						
					path: 'incrementalBaseRate',
					header: 'Base Rate',
					'text-align': 'end',
					width: '9em'
				},
				{						
					path: 'incrementalRate',
					header: 'Incremental Rate',
					'text-align': 'end',
					width: '9em'
				},
				{						
					path: 'incrementalStartWt',
					header: 'Start Weight',
					'text-align': 'end',
					width: '9em'
				},
				{						
					path: 'incrementalWt',
					header: 'Weight',
					'text-align': 'end',
					width: '7em'
				},
				{						
					path: 'weightUom',
					header: 'Weight UOM',
					'text-align': 'center',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}
				}
			}
		});	
				
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							filterField: ElementUtil.query(toolbarFilter, 'filterType').value,
							filterValue: ElementUtil.query(toolbarFilter, 'filterValue').value
						};
												
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						FueltaxService.getStateTaxService().getStateTaxTypes(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'state-tax-types',
			onDetail: function() {
				actionExport();
			}
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		typeGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(typeGrid, toolbarFilter, ['filterType','filterValue'], actionRefresh);
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-combo-box',
											label: 'State Tax Type',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'stateTaxTypeCode',
											'class': (record ? 'hide' : ''),
											required: true,
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('StateTaxTypeCode').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},										
										{
											tag: 'vaadin-combo-box',
											label: 'Tax Method Type',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'taxMethodType',
											required: true,
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('TaxMethodType').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Scheduled Code',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'scheduleCode',											
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('ScheduleCode').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Table Code',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'tableCode',											
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('TableCode').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-text-field',											
											name: 'stateTaxDesc',
											label: 'State Tax Description',
											required: true,
											maxLength: 255											
										},
										{										
											tag: 'vaadin-combo-box',
											itemId: 'stateCombo',
											label: 'State / Prov',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'stateProvCode',
											required: true,
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('StateProvCode').then(function(data){													
													combo.items = data;													
												});
											},
											placeHolder: 'Select'					
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Haul Type',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'haulType',											
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('HaulType').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Laden/Unladen',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'ladenUnladenInd',											
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('LadenUnladenCode').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Vehicle Type',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'tractorTruckInd',											
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('TaxTractorTruckIndicator').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Max Calc Flag',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'incrementalMaxCalcFlag',											
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('YesNoFlag').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'vaadin-number-field',
											name: 'incrementalBaseRate',
											required: true,
											label: 'Base Rate',
											value: 0
										},
										{
											tag: 'vaadin-number-field',
											name: 'incrementalRate',
											required: true,
											label: 'Rate',
											value: 0
										},
										{
											tag: 'vaadin-number-field',
											name: 'incrementalStartWt',
											required: true,
											label: 'Start Weight',
											value: 0
										},
										{
											tag: 'vaadin-number-field',
											name: 'incrementalWt',
											required: true,
											label: 'Weight',
											value: 0
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Weight UOM',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'weightUom',
											required: true,
											value: 'LB',
											postinit: function(combo) {	
												Service.getLookupService().getLookupValues('WeightUOM').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select'
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																												
															formPanel.submitForm({
																preSubmit: function(data) {		
																	var countryCode = ElementUtil.query(formPanel, 'stateCombo').selectedItem.country;
																	data.countryCode = countryCode;
																	
																	if (data.scheduleCode === '') {
																		delete data.scheduleCode;
																	}
																	
																	if (data.tableCode === '') {
																		delete data.tableCode;
																	}
																	
																	if (data.haulType === '') {
																		delete data.haulType;
																	}
																	
																	if (data.ladenUnladenInd === '') {
																		delete data.ladenUnladenInd;
																	}
																	
																	if (data.tractorTruckInd === '') {
																		delete data.tractorTruckInd;
																	}
																	
																	return data;
																},
																actualCall: function(data) {
																	if (record) {
																		data.stateTaxTypeCode = record.stateTaxTypeCode;
																	}																	
																	return FueltaxService.getStateTaxService().saveStateTaxType(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved State Tax Type', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {	
							formPanel.load(record);							
						}
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected type?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							FueltaxService.getStateTaxService().deleteStateTaxType(record.stateTaxTypeCode)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
					
		};	
		
		var actionUpload = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Import State Type File',
				icon: 'vaadin:upload',
				width: 450,
				height: 220,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var uploadHandler = function() {
							
							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');
							
							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A import file is required.');
							} else {
								uploadField.uploadFiles();
							}
							
						};
						
						var uploadFormPanel = ElementUtil.create({
								tag: 'dl-form-panel',
								itemid: 'form',
								children: [
									{
										tag: 'vaadin-upload',												
										itemid: 'uploadField',
										'no-auto':  true,
										'max-files': 1,
										required: true,
										target: '/api/resource/state-tax-types/import',
										headers: ImportUtil.getUploadHeader(),
										listeners: {
											'upload-request': function(event) {
												//var data = uploadFormPanel.getData();												
																							
											},
											'upload-success': function(event) {
												var responseData = JSON.parse(event.detail.xhr.responseText);
												if (responseData.uploadFile) {
													//error 
													window.DL.MessageUtil.showOkMessage(
														responseData.uploadFile + '<br>' +
														responseData.uploadFileType ? responseData.uploadFileType : ''
													);
												} else {
													window.DL.MessageUtil.showToast('Uploaded Successfully', '', {
														theme: 'success'
													});
													
													actionRefresh();
													uploadWin.close();
												}
											}
										}
									},
									{
										tag: 'vaadin-form-layout',										
										children: [											
											{
												tag: 'hr',
												colspan: 2
											},
											{
												tag: 'div',
												style: 'text-align: center;',
												colspan: 2,
												defaults: {
													tag: 'vaadin-button'
												},
												children: [
													{
														theme: 'primary',
														children: [
															ElementUtil.makeIcon('vaadin:upload', ' Upload')
														],
														listeners: {
															click: function() {
																if (uploadFormPanel.isValid()) {																	
																	uploadHandler();
																}
															}
														}
													},
													{
														theme: 'tertiary',
														innerHTML: 'Cancel',
														style: 'margin-left: 10px;',
														listeners: {
															click: function() {																
																uploadWin.close();
															}
														}
													}
												]
											}
										]
									}
								]
						});
						uploadWin.addToContentElement(uploadFormPanel);
						
					}
				}
				
				
			});					
			
		};
		
		var actionExport = function() {
			FueltaxService.getStateTaxService().exportStateTaxType(grid.currentFilter);	
		};
		
	}
	
}
customElements.define('dl-statetype-grid', StateTaxTypeGrid);
